export const zipCodeRegex = /^[0-9]{4,5}$/;
export const websiteRegex =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/;
